import { createRouter, createWebHistory } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import DashLayout from "@/layouts/DashLayout.vue";
import HomePage from "@/views/HomePage.vue"; // Page home
import AuthVeterinaire from "@/views/AuthVeterinaire.vue"; // Page Auth Vétérinaire
import AuthClient from "@/views/AuthClient.vue"; // Page Auth Propriétaire
import AuthDelegue from "@/views/AuthDelegue.vue"; // Page Auth Délégué
import CreateCompteClient from "@/views/CreateCompteClient.vue"; // Page Create compte Propriétaire
import RegisterClient from "@/views/RegisterClient.vue"; // Page Register Client Propriétaire
import ForgetPasswordClient from "@/views/ForgetPasswordClient.vue"; // Page mot de passe oublié Propriétaire
import ForgetPasswordVeterinaire from "@/views/ForgetPasswordVeterinaire.vue"; // Page mot de passe oublié Propriétaire
import ResetPassword from "@/views/ResetPassword.vue"; // Page reset mot de passe
/*************************************Supplyvet pages*************************************************/
import HomeDash from "@/views/HomeDash.vue"; // Page home dashboard
import MyAccount from "@/views/MyAccount.vue"; // Page account dashboard
import ProductListPage from "@/views/supplyvet/ProductListPage.vue"; // Page des produits
import taxonList from "@/views/supplyvet/taxonlist.vue"; // Page des produits par taxon
import ProductsFavoritePage from "@/views/supplyvet/ProductsFavoritePage.vue"; // Page des produits favoris
import ProductDetail from "@/views/supplyvet/ProductDetail.vue"; // Page des produits
import Cart from "@/views/supplyvet/Cart.vue"; // Page de panier
import Livraison from "@/views/supplyvet/Livraison.vue"; //Page de livraison
import LivraisonClinique from "@/views/supplyvet/LivraisonClinique.vue"; //Page de livraison clinique
import LivraisonDomicile from "@/views/supplyvet/LivraisonDomicile.vue"; //Page de livraison à domicile
import LivraisonPointRelais from "@/views/supplyvet/LivraisonPointRelais.vue"; //Page de livraison point relais
import ModeLivraison from "@/views/supplyvet/ModeLivraison.vue"; //Page mode livraison
import PaymentView from "@/views/supplyvet/PaymentView.vue"; //Page de payment
import ArticleView from "@/views/e-supplyvet/ArticleView.vue";
import ArtirclListView from "@/views/ArtirclListView.vue";
/*************************************Internal pages*************************************************/
import ContactView from "@/views/ContactView.vue";
import ContactViewClient from "@/views/ContactViewClient.vue";
import FaqView from "@/views/FaqView.vue";
import AboutView from "@/views/AboutView.vue";
import FideliteView from "@/views/FideliteView.vue";
import ModePaiement from "@/views/supplyvet/ModePaiement.vue";
import { useRegisterStore } from "@/stores/register";
// import DelegueDashboard from "@/views/DelegueDashboard.vue";
import SelectionAdresseRelaisPage from "@/views/supplyvet/Livraison-before-relais.vue"; // Page de sélection d'adresse relais
import PaymentSuccess from "@/views/PaymentSuccess.vue";
import PaymentFailed from "@/views/PaymentFailed.vue";
import WidgetView from "@/views/WidgetView.vue";
import AuthEnTantQue from "@/components/AuthEnTantQue.vue";
import NotFound from "@/views/NotFound.vue"; // Page 404

const routes = [
  {
    path: "/",
    component: AuthLayout,
    children: [
      {
        path: "/",
        name: "Home",
        component: HomePage,
      },
      {
        path: "/login-veterinaire",
        name: "login-veterinaire",
        component: AuthVeterinaire,
      },
      {
        path: "/login-proprietaire",
        name: "login-proprietaire",
        component: AuthClient,
      },
      {
        path: "/login-delegue",
        name: "login-delegue",
        component: AuthDelegue,
      },
      {
        path: "/create-compte",
        component: CreateCompteClient,
      },
      {
        path: "/inscription-proprietaire",
        name: "proprietaire-register",
        component: RegisterClient,
      },
      {
        path: "/forget-password-proprietaire",
        name: "forget-password-proprietaire",
        component: ForgetPasswordClient,
      },
      {
        path: "/forget-password-veterinaire",
        name: "forget-password-veterinaire",
        component: ForgetPasswordVeterinaire,
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPassword,
      },
    ],
  },

   {
    path: '/widget',
    name: 'Widget',
    component: WidgetView
  },
  {
    path: "/mon-compte",
    component: DashLayout,
    // meta: { requiresAuth: true },
    meta: {
      requiresAuth: true,
      requiresSubscription: [
        "commandes_clients",
        "facture_clients",
        "catalogue",
        "frais_port",
        "offre_fidelete",
        "presentation",
        "communication",
        "informations_personnels"
      ],
    },
    children: [
      {
        path: "",
        name: "my-account",
        component: MyAccount,
      },
    ],
  },
  {
    path: "/contact",
    component: ContactView,
    meta: { requiresAuth: true },
    name: "contact-page",
  },
  {
    path: "/contact-client",
    component: ContactViewClient,
    meta: { requiresAuth: true },
    name: "contact-page-client",
  },
  {
    path: "/fidelite-client",
    component: FideliteView,
    meta: { requiresAuth: true },
    name: "fidelite-page",
  },
  {
    path: "/faq",
    component: FaqView,
    meta: { requiresAuth: true },
    name: "Faq-page",
  },
  {
    path: "/qui-sommes-nous",
    component: AboutView,
    meta: { requiresAuth: true },
    name: "About-page",
  },

  {
    path: '/auth-en-tant-que',
    name: 'AuthEnTantQue',
    component: AuthEnTantQue,
  },
  {
    path: "/dashboard",
    component: DashLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "dashboard-home",
        component: HomeDash,
      },
      {
        path: "products",
        name: "supplyvet-products",
        component: ProductListPage,
      },
      {
        path: "taxon/:slug",
        name: "taxonList",
        component: taxonList,
      },
      {
        path: "my-favorite-products",
        name: "favorite-products",
        component: ProductsFavoritePage,
      },
      {
        path: "/product/:slug",
        name: "ProductDetail",
        component: ProductDetail,
      },
      {
        path: "/actualite/:slug",
        name: "pageDetailView",
        component: ArticleView,
      },
      {
        path: "/page/:slug",
        name: "pageDetailView",
        component: ArticleView,
      },
      {
        path: "/actualites",
        name: "PageListView",
        component: ArtirclListView,
      },
      {
        path: "/cart",
        name: "my-cart",
        component: Cart,
      },
      {
        path: "/livraison",
        name: "livraison",
        component: Livraison,
      },
      {
        path: "/mode-livraison",
        name: "mode-livraison",
        component: ModeLivraison,
      },
      {
        path: "/mode-paiement",
        name: "mode-paiement",
        component: ModePaiement,
      },
      {
        path: "/selection-adresse-relais",
        name: "selection-adresse-relais",
        component: SelectionAdresseRelaisPage,
      },

      {
        path: "/paiement/:orderToken",
        name: "paiement",
        component: PaymentView,
        props: true,
      },

      {
        path: "/livraison-clinique",
        name: "livraison-clinique",
        component: LivraisonClinique,
      },
      {
        path: "/livraison-domicile",
        name: "livraison-domicile",
        component: LivraisonDomicile,
      },
      {
        path: "/livraison-point-relais",
        name: "livraison-point-relais",
        component: LivraisonPointRelais,
      },
    ],
  },

  {
    path: "/checkout/complete/:orderToken",
    name: "checkout-complete",
    component: PaymentSuccess,
    props: true,
  },
  {
    path: "/checkout/failed/:orderToken",
    name: "checkout-failed",
    component: PaymentFailed,
    props: true,
  },
  // Catch-all route for 404 - must be last
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard to check authentication and role
router.beforeEach(async (to, from, next) => {
  const registerStore = useRegisterStore();
  const isAuthenticated = localStorage.getItem("token");
  const user = registerStore.user;

  // Redirect authenticated users from auth pages to dashboard
  const authPages = ["/", "/forget-password-veterinaire", "/forget-password-proprietaire", "/create-compte", "/login-proprietaire", "/login-veterinaire", "/login-delegue", "/inscription-proprietaire", ];
  if (isAuthenticated && authPages.includes(to.path)) {
    next({ name: "dashboard-home" });
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: "Home" });
    return;
  }

  if (to.meta.requiresAuth && isAuthenticated && user?.role === "veterinaire") {
    try {
      if (!registerStore.hasEssentialVeterinaryData()) {
        await registerStore.fetchVeterinaire();
      } else {
        const now = Date.now();
        const cacheExpired = now - registerStore.lastVeterinaryFetchTime >= registerStore.veterinaryCacheDuration;
        if (cacheExpired) {
          registerStore.fetchVeterinaire().catch(error => {
            console.warn("Erreur lors du rafraîchissement en arrière-plan:", error);
          });
        }
      }
    } catch (error) {
      console.error("Erreur lors du chargement des données vétérinaire:", error);
    }
  }

  // Check subscription for restricted tabs in my-account
  if (to.name === "my-account" && to.query.tab) {
    const restrictedTabs = to.matched[0].meta.requiresSubscription || [];
    if (restrictedTabs.includes(to.query.tab) && !registerStore.Veterinaire.hasSubscription) {
      // Redirect to default tab (tableau_bord)
      next({ name: "my-account", query: { tab: "tableau_bord" } });
      return;
    }
  }

  next();
});

// Scroll behavior to scroll to top on route change
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
